"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertActionItemHtmlToSlateNode = convertActionItemHtmlToSlateNode;
exports.createActionItemDeserializerPlugin = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateList = require("@udecode/plate-list");
var ACTION_ITEM_DESERIALIZER_PLUGIN_KEY = 'action-item-deserializer-plugin';
function convertActionItemHtmlToSlateNode(editor, element) {
  // find the nested child element with role=checkbox and get the data-state
  var checkbox = element.querySelector('[role=checkbox]');
  var checkboxChecked = (checkbox === null || checkbox === void 0 ? void 0 : checkbox.getAttribute('data-state')) === 'checked';
  return {
    type: (0, _plateCommon.getPluginType)(editor, _plateList.ELEMENT_TODO_LI),
    checked: checkboxChecked
  };
}
var createActionItemDeserializerPlugin = exports.createActionItemDeserializerPlugin = (0, _plateCommon.createPluginFactory)({
  key: ACTION_ITEM_DESERIALIZER_PLUGIN_KEY,
  then: function then(editor) {
    return {
      deserializeHtml: {
        getNode: function getNode(element) {
          return convertActionItemHtmlToSlateNode(editor, element);
        },
        isElement: true,
        rules: [{
          validClassName: 'slate-action_item'
        }]
      }
    };
  }
});